import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, ViewContainerRef } from "@angular/core";
import { SharedService } from '../shared';
import {
    EnumQuestionType, EnumSectionType, IQuestionnaireResponse, IQuestionnaireResponseData,
    getCategoryLabel, EnumCAMTherapieName, freeTextInputs, LANGUAGE_ENUM, getFormCategoryLabels
} from '../dateneingabe-frageboge/questionnaire.model';
import {
    freeTextInput, IndikationOptions, QuestionnaireJSON
} from '../dateneingabe-frageboge/questionnaire.data';
import { CamProductList } from '../dateneingabe-frageboge/productList'
import { CardDetailPopupComponent } from '../card-detail-popup';
import { cloneDeep, uniq } from 'lodash';
import * as moment from 'moment';

declare var jsPanel: any;

@Component({
    selector: 'app-datenebank-cards',
    templateUrl: "./datenebank-cards.component.html",
    styleUrls: ["./datenebank-cards.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DatenebankCardsComponent implements OnInit {
    showLoader: boolean = false;

    dataList: any[] = [];
    totalRecord: number = 0;

    searchPayload = {
        Beschwerdebilds: null,
        Indikations: null,
        Symptoms: null,
        Keyword: null,
        Alters: null,
        Geschlechts: null,
        CAMTherapies: null
    }

    searchPayloadError = {
        Beschwerdebild: false,
        Indikation: false,
        Symptom: false
    }

    pageIndex: number = 0;
    pageSize: number = 25;
    pageSizeOptions: number[] = [10, 25, 50, 100];
    paginationSize: number = 5;//display how many items in paginations row
    sortBy: "Created" = "Created";
    sortOrder: "ASC" | "DESC" = "DESC";

    beschwerdebildData: any[] = [];
    indikationData: any[] = [];
    symptomData: any[] = [];
    ageGroupData: any[] = ["<21", "21-40", "41-65", ">65"];

    dropdownData: any[] = [];

    jsPanelPopup: any;

    get panelWidth() {
        return Math.min(1400, window.innerWidth * 0.9);
    }

    get panelHeight() {
        return Math.min(1100, window.innerHeight * 0.9);
    }

    get cardPanelWidth() {
        return Math.min(3500, window.innerWidth - 60);
    }

    get cardPanelHeight() {
        return Math.min(1000, window.innerHeight - 60);
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        const queries = this.sharedService.getUrlVars();
        const dc = queries["dc"];
        const dc_timestamp = queries["dc_timestamp"];
        if (dc && dc_timestamp) {
            this.cd.detectChanges();
            this.fnLoadDropdowns();
            this.fnSearchDatenebank();
        } else {
            window.open("/pep/search/doccheck", "_self");
        }
    }

    fnLoadBeschwedDDL() {
        this.beschwerdebildData = [];
        IndikationOptions.forEach(indiOption => {
            let ind = this.beschwerdebildData.findIndex(a => a.Value == indiOption.label);
            if (ind < 0) {
                this.beschwerdebildData.push({ Value: indiOption.label, Disabled: true });
            }
        })
    }

    fnLoadIndkikationData() {
        this.indikationData = [];
        IndikationOptions.forEach(indiOption => {
            var options = indiOption.options;
            let freeTextInd = options.indexOf(freeTextInput);
            if (freeTextInd >= 0) {
                options.splice(freeTextInd, 1);
            }
            options.forEach(option => {
                let ind = this.indikationData.findIndex(a => a.Value == option);
                if (ind < 0) {
                    this.indikationData.push({ Value: option, Disabled: true });
                }
            })
        })
    }

    fnLoadSymptomData() {
        this.symptomData = [];
        let ss = QuestionnaireJSON.find(s => s.number == 4);
        if (ss) {
            let sss = ss.subSections.find(s => s.number == 1);
            if (sss) {
                sss.questions.forEach(quest => {
                    quest.data.forEach(option => {
                        let ind = this.symptomData.findIndex(a => a.Value == option);
                        if (ind < 0) {
                            this.symptomData.push({ Value: option, Disabled: true });
                        }
                    })
                })
            }
        }
    }

    fnLoadDropdowns() {
        this.sharedService.getDateneingabeDDL().subscribe({
            next: (res) => {
                this.dropdownData = res;

                this.fnSetBeschwedDDL();
                this.fnSetIndikationDDL();
                this.fnSetSymptomDDL();
            },
            error: (err) => {
                this.dropdownData = [];
                this.fnSetBeschwedDDL();
                this.fnSetIndikationDDL();
                this.fnSetSymptomDDL();
            }
        })
    }

    fnSetBeschwedDDL() {
        this.fnLoadBeschwedDDL();
        var options = this.dropdownData.map(a => a.Beschwerdebild);
        options = uniq(options);
        this.beschwerdebildData.forEach(item => {
            if (options.indexOf(item.Value) >= 0) {
                item.Disabled = false;
            } else {
                item.Disabled = true;
            }
        })
        this.beschwerdebildData.sort((a, b) => a.Disabled - b.Disabled);
    }

    fnSetIndikationDDL() {
        this.fnLoadIndkikationData();
        this.searchPayload.Indikations = null;

        var indiOptions = this.dropdownData;
        if (this.searchPayload.Beschwerdebilds != null && this.searchPayload.Beschwerdebilds.length > 0) {
            indiOptions = this.dropdownData.filter(a => this.searchPayload.Beschwerdebilds.indexOf(a.Beschwerdebild) >= 0);
        }
        let options = indiOptions.filter(a => a.IndikationAndre != true).map(a => a.Indikation);
        options = uniq(options);
        this.indikationData.forEach(item => {
            if (options.indexOf(item.Value) >= 0) {
                item.Disabled = false;
            } else {
                item.Disabled = true;
            }
        })
        var andreOptions = indiOptions.filter(a => a.IndikationAndre != false).map(a => a.Indikation);
        andreOptions = uniq(andreOptions);
        andreOptions.forEach(option => {
            let ind = this.indikationData.findIndex(a => a.Value == option);
            if (ind < 0) {
                this.indikationData.push({ Value: option, Disabled: false });
            }
        })
        this.indikationData.sort((a, b) => a.Disabled - b.Disabled);
    }

    fnSetSymptomDDL() {
        this.fnLoadSymptomData();
        this.searchPayload.Symptoms = null;

        var sympOptions = this.dropdownData;
        if (this.searchPayload.Beschwerdebilds != null && this.searchPayload.Beschwerdebilds.length > 0) {
            sympOptions = this.dropdownData.filter(a => this.searchPayload.Beschwerdebilds.indexOf(a.Beschwerdebild) >= 0);
        }
        if (this.searchPayload.Indikations != null && this.searchPayload.Indikations.length > 0) {
            sympOptions = this.dropdownData.filter(a => this.searchPayload.Indikations.indexOf(a.Indikation) >= 0);
        }
        var allSymptoms = [];
        sympOptions.forEach(symp => {
            allSymptoms = [...allSymptoms, ...symp.Symptoms];
        })
        var options = allSymptoms.filter(a => a.Andre != true).map(a => a.Value);
        options = uniq(options);
        this.symptomData.forEach(item => {
            if (options.indexOf(item.Value) >= 0) {
                item.Disabled = false;
            } else {
                item.Disabled = true;
            }
        })
        var andreOptions = allSymptoms.filter(a => a.Andre != false).map(a => a.Value);
        andreOptions = uniq(andreOptions);
        andreOptions.forEach(option => {
            let ind = this.symptomData.findIndex(a => a.Value == option);
            if (ind < 0) {
                this.symptomData.push({ Value: option, Disabled: false });
            }
        })
        this.symptomData.sort((a, b) => a.Disabled - b.Disabled);
    }


    fnResetSearch() {
        this.searchPayload = {
            Beschwerdebilds: null,
            Indikations: null,
            Symptoms: null,
            Keyword: null,
            Alters: null,
            Geschlechts: null,
            CAMTherapies: null
        }
        this.fnSearchData();
    }

    fnResetError() {
        this.searchPayloadError = {
            Beschwerdebild: false,
            Indikation: false,
            Symptom: false
        }
    }

    changeBeschwerdebild() {
        this.searchPayloadError.Beschwerdebild = false;
        this.fnSetIndikationDDL();
        this.fnSetSymptomDDL();
    }

    changeIndikation() {
        this.searchPayloadError.Indikation = false;
        this.fnSetSymptomDDL();
    }

    changeSymptom() {
        this.searchPayloadError.Symptom = false;
    }

    isValueInArr(Arr, value) {
        if (!Arr) {
            Arr = [];
        }
        return Arr.indexOf(value) > -1;
    }

    getFormSVGColor(Arr, value) {
        return this.isValueInArr(Arr, value) ? "#D6ECFF" : "#F8F8F4";
    }

    changeAlters(ageGroup) {
        if (!this.searchPayload.Alters) {
            this.searchPayload.Alters = [];
        }
        let index = this.searchPayload.Alters.indexOf(ageGroup);
        if (index > -1) {
            this.searchPayload.Alters.splice(index, 1);
        } else {
            this.searchPayload.Alters.push(ageGroup);
        }
    }

    changeGeschlecht(gender) {
        if (!this.searchPayload.Geschlechts) {
            this.searchPayload.Geschlechts = [];
        }
        let index = this.searchPayload.Geschlechts.indexOf(gender);
        if (index > -1) {
            this.searchPayload.Geschlechts.splice(index, 1);
        }
        else {
            this.searchPayload.Geschlechts.push(gender);
        }
    }

    changeCAMTHerapie(therapie) {
        if (!this.searchPayload.CAMTherapies) {
            this.searchPayload.CAMTherapies = [];
        }
        let index = this.searchPayload.CAMTherapies.indexOf(therapie);
        if (index > -1) {
            this.searchPayload.CAMTherapies.splice(index, 1);
        }
        else {
            this.searchPayload.CAMTherapies.push(therapie);
        }
    }

    getSubSections(item: IQuestionnaireResponseData, sectionNumber, subSectionNumber) {
        let subSections = item.JsonData.filter(a => a.sectionNumber == sectionNumber && a.subSectionNumber == subSectionNumber);
        return subSections;
    }

    getQuestion(item: IQuestionnaireResponseData, sectionNumber, subSectionNumber, questionNumber) {
        let subSections = this.getSubSections(item, sectionNumber, subSectionNumber);
        let question = subSections.find(a => a.questionNumber == questionNumber);
        return question;
    }

    getQuestionValue(item: IQuestionnaireResponseData, sectionNumber, subSectionNumber, questionNumber) {
        let question = this.getQuestion(item, sectionNumber, subSectionNumber, questionNumber);
        if (question) {
            let freeText = question.response["freeText"];
            let value = question.response["value"];
            if (value && typeof value == 'object') {
                value = value.join(",");
            }
            return freeText || value;
        }
        return "";
    }

    getGender(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 2, 1, 6);
        return value;
    }

    getGenderImage(item: IQuestionnaireResponseData) {
        let value = this.getGender(item);
        var Geschlechts = this.searchPayload.Geschlechts || [];
        var active = Geschlechts.indexOf(value) > -1 ? true : false;
        switch (value) {
            case 'Weiblich':
                return active ? "/pep/images/icons/woman active.svg" : "/pep/images/icons/woman.svg";
            case 'Divers':
                return active ? "/pep/images/icons/diverse active.svg" : "/pep/images/icons/diverse.svg";
            default:
                return active ? "/pep/images/icons/man active.svg" : "/pep/images/icons/man.svg";
        }
    }

    isGenederFiltered(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 2, 1, 6);
        if (this.searchPayload.Geschlechts.indexOf(value) > -1) {
            return true;
        }
        return false;
    }

    createdMonth(item: IQuestionnaireResponseData) {
        return this.getMonthFromDate(this.createdDate(item), 'END');
    }

    createdDate(item: IQuestionnaireResponseData) {
        return moment(item.Created);
    }

    getMonthFromDate(date: any, type: 'END' | 'START') {
        var mDate = moment(new Date(date));
        if (type == 'END') {
            return mDate.endOf("month");
        } else {
            return mDate.startOf("month");
        }
    }

    getBeobachtungszeitpunktDate(item: IQuestionnaireResponseData) {
        let question = this.getQuestion(item, 2, 1, 2);
        if (question) {
            let value = question.response["value"];
            if (value) {
                let date = moment(value);
                if (date.isValid()) {
                    return this.getMonthFromDate(date, 'END');
                }
            }
        }
        return null;
    }

    beobOrDocumentDate(item: IQuestionnaireResponseData) {
        if (this.getBeobachtungszeitpunktDate(item)) {
            return this.getBeobachtungszeitpunktDate(item);
        } else {
            return this.createdMonth(item);
        }
    }

    getAge(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 2, 1, 3);
        if (value) {
            let year = this.beobOrDocumentDate(item).year();
            let diff = year - parseInt(value);
            return `${diff} Jahre`;
        }
        return "";
    }

    getAgeActive(item: IQuestionnaireResponseData) {
        let matched = false;
        let age = this.getAge(item);
        age = age.replace("Jahre", "").trim();
        if (age.length) {
            let value = parseInt(age);
            let Alters = this.searchPayload.Alters || [];
            for (let i = 0; i < Alters.length; i++) {
                let alter = Alters[i];
                switch (alter) {
                    case '<21':
                        if (value < 21) {
                            matched = true;
                        }
                        break;
                    case '21-40':
                        if (value >= 21 && value <= 40) {
                            matched = true;
                        }
                        break;
                    case '41-65':
                        if (value >= 41 && value <= 65) {
                            matched = true;
                        }
                        break;
                    case '>65':
                        if (value > 65) {
                            matched = true;
                        }
                        break;
                }
            }
        }
        return matched;
    }

    getVersicherung(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 2, 1, 10);
        if (value) {
            var Berufstatig = this.getBerufstatig(item);
            if (Berufstatig) {
                return `${value == 'Gesetzlich versichert' ? 'GKV' : 'PKV'}, ${Berufstatig}`;
            } else {
                return value == 'Gesetzlich versichert' ? 'GKV' : 'PKV';
            }
        }
        return "";
    }

    getBerufstatig(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 2, 1, 8);
        return value;
    }

    getBeschwerdebild(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 3, 1, 1);
        return value;
    }

    getBeschwerdebildActive(item: IQuestionnaireResponseData) {
        let value = this.getBeschwerdebild(item);
        var Beschwerdebilds = this.searchPayload.Beschwerdebilds || [];
        var active = Beschwerdebilds.indexOf(value) > -1 ? true : false;
        return active;
    }

    getIndikation(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 3, 1, 2);
        return value;
    }

    getIndikationActive(item: IQuestionnaireResponseData) {
        let value = this.getIndikation(item);
        var Indikations = this.searchPayload.Indikations || [];
        var active = Indikations.indexOf(value) > -1 ? true : false;
        return active;
    }

    getWeitereDiagnosen(item: IQuestionnaireResponseData) {
        let question = this.getQuestion(item, 3, 1, 5);
        if (question) {
            const stringOptions = question.response["extraOptions"]
                .map(opt => {
                    if (typeof opt === 'string') return opt;
                    if (typeof opt === 'object' && opt !== null) {
                        return opt.value;
                    }
                    return null;
                })
                .filter(opt => typeof opt === 'string');
            return stringOptions;
        }
        return [];
    }

    getWeitereDiagnosenActive(value: string) {
        var Indikations = this.searchPayload.Indikations || [];
        var active = Indikations.indexOf(value) > -1 ? true : false;
        return active;
    }

    getSymptomesBG(option) {
        if (option.after.value < option.before.value) {
            return "#1EAB50";
        }
        else if (option.after.value > option.before.value) {
            return "#C83232";
        }
        else {
            return "#6E6E6E";
        }
    }

    getSymptomes(item: IQuestionnaireResponseData) {
        let subSections = this.getSubSections(item, 4, 2);
        if (subSections.length) {
            let subSection = subSections[0];
            let symptomes = subSection.response;
            return symptomes;
        }
        return [];
    }

    getSymptomesActive(value: string) {
        var Symptoms = this.searchPayload.Symptoms || [];
        var active = Symptoms.indexOf(value) > -1 ? true : false;
        return active;
    }

    getCamTherapie(item: IQuestionnaireResponseData) {
        let subSections = item.JsonData.filter(a => a.sectionNumber == 7 && a.subSectionType == EnumSectionType.CAMTHERAPIE && a.inputType == EnumCAMTherapieName.CAMTherapie);
        let response: any = [];
        if (subSections.length) {
            subSections.forEach(subSection => {
                let res: any[] = subSection.response as any[];
                response = [...response, ...res]
            })
        }
        return response;
    }

    getCamTherapieEnd(item: IQuestionnaireResponseData) {
        let subSections = item.JsonData.filter(a => a.sectionNumber == 7 && a.subSectionType == EnumSectionType.CAMTHERAPIE && a.inputType == EnumCAMTherapieName.CAMTherapieEnd);
        let response: any = [];
        if (subSections.length) {
            subSections.forEach(subSection => {
                let res: any[] = subSection.response as any[];
                response = [...response, ...res]
            })
        }
        return response;
    }

    showCamTherapie(option) {
        let category = option.category.value;
        if (category) {
            return true;
        }
        return false;
    }

    getCamTherapieIcon(option) {
        let value = option.category.value;
        var label = getCategoryLabel(value, LANGUAGE_ENUM.DE);
        var CAMTherapies = this.searchPayload.CAMTherapies || [];
        var active = false;

        switch (label) {
            case 'Extrakte':
            case 'Dronabinol':
            case 'Sativex':
                active = CAMTherapies.indexOf("oral") > -1 ? true : false;
                return active ? "/pep/images/icons/oral active.svg" : "/pep/images/icons/oral.svg";
            case 'Canemes':
            case 'Kapseln':
                active = CAMTherapies.indexOf("per os") > -1 ? true : false;
                return active ? "/pep/images/icons/per os active.svg" : "/pep/images/icons/per os.svg";
            case 'Andere':
                return "/pep/images/icons/Andere - icon.svg";
            default:
                active = CAMTherapies.indexOf("inhalativ") > -1 ? true : false;
                return active ? "/pep/images/icons/inhalativ active.svg" : "/pep/images/icons/inhalativ.svg";
        }
    }

    getCamTherapieLabel(option) {
        let freeText = option.product.freeText;
        if (freeText) {
            return freeText;
        } else {
            let category = option.category.value;
            let product = option.product.value;
            if (product) {
                var label = getCategoryLabel(category, LANGUAGE_ENUM.DE);
                let data = CamProductList.find(a => a.label == label).options;
                let productItem = data.find(a => a.label == product);
                if (productItem && productItem.partner) {
                    return product;
                }
            }
            switch (category) {
                case "Andere":
                    return product;
                default:
                    return category;
            }
        }

    }

    getCamTherapieValue(option) {
        let freeText = option.product.freeText;
        if (freeText) {
            if (option.product['thc'] && option.product['cbd']) {
                return `${option.product['thc']}/${option.product['cbd']}`;
            } else {
                const match = freeText.match(/\(([^)]+)\)/);
                const value = match ? match[1] || "" : null;
                return value;
            }
        } else {
            let category = option.category.value;
            let product = option.product.value;
            if (product) {
                var label = getCategoryLabel(category, LANGUAGE_ENUM.DE);
                let data = CamProductList.find(a => a.label == label).options;
                let productItem = data.find(a => a.label == product);
                if (productItem) {
                    //if (productItem.partner) {
                    //    return null;
                    //} else {
                    return productItem.thc_cbd;
                    //}
                }
            }
            return null;
        }
    }


    getZusammenfassung(item: IQuestionnaireResponseData) {
        let value = this.getQuestionValue(item, 9, 1, 2);
        return value;
    }

    getZusammenfassungBG(item: IQuestionnaireResponseData) {
        switch (this.getZusammenfassung(item)) {
            case 'Stark verbessert':
                return "#155D1F";
            case 'Verbessert':
                return "#1EAB50";
            case 'Gering verbessert':
                return "#09ED5B";
            case 'Gering verschlechtert':
                return "#F77171";
            case 'Verschlechtert':
                return "#C83232";
            case 'Stark verschlechtert':
                return "#FF0000";
            default:
                return "#6E6E6E";
        }
    }

    isFreeTextData(obj: IQuestionnaireResponse) {
        if (obj.inputType == EnumQuestionType.DROPDOWN) {
            let value = obj.response["value"]
            if (typeof value == 'object') {
                var matched = freeTextInputs.filter(e => value.indexOf(e) !== -1);
                return matched.length > 0;
            } else {
                return freeTextInputs.indexOf(value) > -1;
            }
        }
        return false;
    }

    fnSearchData() {
        this.fnResetError();
        let Valid = true;
        //if (!this.searchPayload.Beschwerdebilds || this.searchPayload.Beschwerdebilds.length == 0) {
        //    Valid = false;
        //    this.searchPayloadError.Beschwerdebild = true;
        //}
        //if (!this.searchPayload.Indikations || this.searchPayload.Indikations.length == 0) {
        //    Valid = false;
        //    this.searchPayloadError.Indikation = true;
        //}
        //if (!this.searchPayload.Symptoms || this.searchPayload.Symptoms.length == 0) {
        //    Valid = false;
        //    this.searchPayloadError.Symptom = true;
        //}
        if (Valid) {
            this.fnSearchDatenebank();
        }
    }

    changeSortOrder(sortOrder) {
        if (this.sortOrder != sortOrder) {
            this.sortOrder = sortOrder;
            this.fnSearchDatenebank();
        }
    }

    changePageSize() {
        this.fnSearchDatenebank();
    }

    paginationChanged(event) {
        this.pageIndex = event.page - 1;
        this.fnSearchDatenebank();
    }

    fnSearchDatenebank() {
        var CAMTherapies = [];
        if (this.searchPayload.CAMTherapies && this.searchPayload.CAMTherapies.length > 0) {
            this.searchPayload.CAMTherapies.forEach(item => {
                var options = getFormCategoryLabels(item, LANGUAGE_ENUM.DE);
                CAMTherapies = [...CAMTherapies, ...options];
            })
        }
        let payload: any = {
            PageIndex: this.pageIndex,
            PageSize: this.pageSize,
            SortBy: this.sortBy,
            SortOrder: this.sortOrder,
            Beschwerdebilds: this.searchPayload.Beschwerdebilds || [],
            Indikations: this.searchPayload.Indikations || [],
            Symptoms: this.searchPayload.Symptoms || [],
            Keyword: this.searchPayload.Keyword || "",
            Alters: this.searchPayload.Alters || [],
            Geschlechts: this.searchPayload.Geschlechts || [],
            CAMTherapies: CAMTherapies,
        };
        this.showLoader = true;
        this.sharedService.searchDatenebank(payload).subscribe({
            next: (res) => {
                let { Data, Total } = res;
                this.totalRecord = Total;
                this.dataList = Data;
                this.showLoader = false;
            },
            error: (err) => {
                this.totalRecord = 0;
                this.dataList = [];
                this.showLoader = false;
            }
        })
    }

    detailView(item: IQuestionnaireResponseData) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const componentRef = this.vcr.createComponent(CardDetailPopupComponent);
        componentRef.instance.pageName = 'CARDS';
        componentRef.instance.cardDetail = cloneDeep(item);
        componentRef.instance.dataList = cloneDeep(this.dataList);

        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            id: "jsPanelFixed",
            theme: 'dark',
            panelSize: {
                width: () => { return component.cardPanelWidth; },
                height: () => { return component.cardPanelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            header: false,
            border: '1px solid #B4B4B4',
            borderRadius: '10px',
            addCloseControl: 1,
            css: {
                content: 'card-detail-popup-container',
                panel: 'card-detail-panel'
            },
            onwindowresize: true,
            dragit: {
                disable: true
            },
            resizeit: {
                disable: true
            },
            onstatuschange: (panel, status) => {
            },
            onclosed: (panel, closedByUser) => {
                this.jsPanelPopup = undefined;
            },
            content: element,
            callback: function (panel) {
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup);
    }

    onResizeWindow(event) {
        if (this.jsPanelPopup) {
            this.jsPanelPopup.resize({
                width: () => { return this.cardPanelWidth; },
                height: () => { return this.cardPanelHeight; }
            }).reposition(); // reposition panel in order to maintain centered position
        }
    }

}
